import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block rounded-lg overflow-hidden bg-background-100 hover:bg-background-200/70 transition-all duration-300 cursor-pointer"
      data-product-shop
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={comic.coverImage}
          alt={`${comic.title} - 韩漫在线观看`}
          title={`${comic.title} - 无删减韩漫`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <p className="text-white text-xs line-clamp-2">{comic.description}</p>
        </div>
        {comic.isHot && (
          <span className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-md font-semibold">
            HOT
          </span>
        )}
        {comic.isNew && (
          <span className="absolute top-2 left-2 bg-accent-500 text-background-950 text-xs px-2 py-0.5 rounded-md font-semibold">
            NEW
          </span>
        )}
        <span className="absolute top-2 right-2 bg-background-950/70 backdrop-blur-sm text-foreground-200 text-xs px-2 py-0.5 rounded-md">
          {comic.status}
        </span>
      </div>
      <div className="p-3">
        <h3 className="text-foreground-50 font-semibold text-sm truncate group-hover:text-primary-400 transition-colors">
          {comic.title}
        </h3>
        <p className="text-foreground-500 text-xs mt-1 truncate">{comic.author}</p>
        <div className="flex items-center justify-between mt-2">
          <div className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            <span className="text-foreground-300 text-xs">{comic.rating}</span>
          </div>
          <span className="text-foreground-500 text-xs">
            {comic.views > 10000
              ? `${(comic.views / 10000).toFixed(1)}万`
              : comic.views}
          </span>
        </div>
      </div>
    </Link>
  );
}